export default __webpack_public_path__ + "static/media/coach-bundle_gray@3x.c2293cbf.jpg";